// src/VerificarCpfModal.js

import React, { useState } from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, Button, Box, Typography
} from '@mui/material';
import { toast } from 'react-toastify';

const VerificarCpfModal = ({ onClose, onCpfCheck }) => {
  const [cpf, setCpf] = useState('');

  const handleVerificar = () => {
    const cpfNumerico = cpf.replace(/\D/g, '');
    if (cpfNumerico.length > 0 && cpfNumerico.length < 11) {
        toast.error('Por favor, digite um CPF válido com 11 dígitos.');
        return;
    }
    onCpfCheck(cpfNumerico);
  };

  return (
    <Dialog open={true} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Verificar Hóspede por CPF</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ pt: 1 }}>
            <Typography variant="body2" color="text.secondary" sx={{mb: 2}}>
                Digite o CPF para verificar se o hóspede já possui cadastro. 
                Se não tiver, você poderá cadastrá-lo.
            </Typography>
            <TextField
                autoFocus
                label="CPF do Hóspede"
                fullWidth
                value={cpf}
                onChange={(e) => setCpf(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleVerificar()}
                placeholder="000.000.000-00"
            />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleVerificar} variant="contained">
          Verificar e Continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VerificarCpfModal;

